import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { StatisticsResource } from '../../../services/resources/statistics.resource';

@Component({
    selector: 'sl-total-dispo',
    templateUrl: './total-dispo.component.html',
    styleUrls: ['./total-dispo.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TotalDispoComponent implements OnInit {
    label: string;
    amount: number;

    private readonly statisticsResource = inject(StatisticsResource);

    ngOnInit(): void {
        this.statisticsResource.getTotalDispo().subscribe(r => {
            this.label = r.value.label;
            this.amount = r.value.value;
        });
    }
}
